import { render, staticRenderFns } from "./BillPaymentsComponent.vue?vue&type=template&id=5ea3d504&scoped=true"
import script from "./BillPaymentsComponent.vue?vue&type=script&lang=js"
export * from "./BillPaymentsComponent.vue?vue&type=script&lang=js"
import style0 from "./BillPaymentsComponent.vue?vue&type=style&index=0&id=5ea3d504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea3d504",
  null
  
)

export default component.exports